import { JCB } from "./dimensions";
import { JcbBody } from "./JcbBody";
import { JCB_4_LAYOUT, JCB_4_WHEELS } from "./wheels";
const jcb4Preset = {
  id: "jcb-4",
  silhouette: "jcb",
  renderModelKey: "jcb",
  renderLayoutKey: "jcb-4-wheel-v1",
  label: "2 axles, single fitment, small steer and large drive wheels",
  layout: JCB_4_LAYOUT,
  wheels: JCB_4_WHEELS,
  camera: {
    position: [6.8, 3.6, 6.2],
    target: [0, 1.4, 0],
    minDistance: 4.5,
    maxDistance: 18,
    fov: 32
  },
  stage: { extent: JCB.length, contactHeight: 1.6 },
  skeleton: "none",
  Body: JcbBody
};
export {
  jcb4Preset
};
